import { useFormContext } from 'react-hook-form';
import { Button } from '@/components/common/Button';
import { TradeFormData, TradeSide } from '../schema';
import { TradeCurrency, TradeCurrencyError } from './TradeCurrency';
import { TradeBreakdown } from '@/components/features/trade/TradeBreakdown/TradeBreakdown';
import type { TradeBreakdown as TradeBreakdownType } from '@/hooks/trade/useTradeBreakdown';
import { OrderType, QuantityType } from '@fintronners/internal-core/src/trade/constants';

const displayStrings = {
  holdings: (amount?: string) => `Current holdings: ${amount ?? '--'}`,
  sellAll: 'Sell All',
};

interface TradeMarketSellFormProps {
  tradeBreakdown: TradeBreakdownType;
  isMutualFund?: boolean;
  isFractionable?: boolean;
}

export const TradeMarketSellForm = ({
  tradeBreakdown,
  isMutualFund,
  isFractionable,
}: TradeMarketSellFormProps) => {
  const { setValue } = useFormContext<TradeFormData>();
  const { shareBalance, shareBalanceInDollars } = tradeBreakdown;

  const handleSellAllClick = () => {
    if (!isFractionable) {
      setValue('shares', shareBalance.toString());
      return;
    }

    setValue('quantityType', QuantityType.DOLLARS);
    setValue('amount', shareBalanceInDollars.toString());
  };

  return (
    <div className="flex flex-col mb-8">
      <div className="flex flex-col gap-2">
        <div>
          <TradeCurrency
            side={TradeSide.SELL}
            isFractionable={isFractionable}
            showUnitToggler={!isMutualFund}
          />

          <div className="mt-2">
            <Button variant="secondary" onClick={handleSellAllClick}>
              {displayStrings.sellAll}
            </Button>
          </div>
        </div>

        <TradeCurrencyError />

        <TradeBreakdown
          orderType={OrderType.MARKET_SELL}
          tradeBreakdown={tradeBreakdown}
          isMutualFund={isMutualFund}
        />
      </div>
    </div>
  );
};
